/**
 * @fileoverview ConstUtil util
 */
'use strict';
// Const Import
import Common from '../const/CommonConst';
import Message from '../const/MessageConst';

export { Common, Message };



// WEBPACK FOOTER //
// ./src/js/util/ConstUtil.jsx